import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ShieldIcon from '@mui/icons-material/Shield';
import WebAccessibilityBody from "../../assets/svg/icons/primary/web-accessibility-body.svg"
import WebAccessibilityBrain from "../../assets/svg/icons/primary/web-accessibility-brain.svg"
import WebAccessibilityEye from "../../assets/svg/icons/primary/web-accessibility-eye.svg"
import WebAccessibilityHand from "../../assets/svg/icons/primary/web-accessibility-hand.svg"
import AppStore from '../../assets/svg/logos/primary/app-store.svg'
import GooglePlay from "../../assets/svg/logos/primary/play-store.svg"

const Accessibility = (props) => {

  const [ isSecure, setIsSecure ] = useState(false);

  useEffect(() => {
    if (window.location.protocol !== "https:") {
      setIsSecure(false)
    } else { setIsSecure(true) }

    return () => {
      setIsSecure();
      console.log("Clean up for checking SSL encryption.")
    }
  }, []);

  return (
    <Box>
      <Box sx={{alignItems: "center", display: "flex", justifyContent: "center",}}>
        <Box
          alt="Body Accessibility Icon"
          component="img"
          height={40}
          loading="lazy"
          src={WebAccessibilityBody}
          sx={{m: 1,}}
          width={40}
        >
        </Box>
        <Box
          alt="Brain Accessibility Icon"
          component="img"
          height={40}
          loading="lazy"
          src={WebAccessibilityBrain}
          sx={{m: 1,}}
          width={40}
        >
        </Box>
        <Box
          alt="Eye Accessiblitiy Icon"
          component="img"
          height={40}
          loading="lazy"
          src={WebAccessibilityEye}
          sx={{m: 1,}}
          width={40}
        >
        </Box>
        <Box
          alt="Hand Accessibility Icon"
          component="img"
          height={40}
          loading="lazy"
          src={WebAccessibilityHand}
          sx={{m: 1,}}
          width={40}
        >
        </Box>
      </Box>
      <Box sx={{alignItems: "center", display: "flex", justifyContent: "center",}}>
        <ShieldIcon sx={{ color: isSecure ? "green" : "red", m:1, }} />
        <Box>
          <Typography fontSize={10}>Designed with accessibility best practices in mind.</Typography>
          <Typography fontSize={10}>This website { isSecure ? "is" : "is not currently"} secured with SSL encription.</Typography>
        </Box>
      </Box>
      <Box sx={{alignItems: "center", display: "flex", justifyContent: "center",}}>
        <Button
          aria-label="Download on the App Store"
          href="https://apps.apple.com/ca/app/personal-architect/id6476518025"
        >
          <Box
            alt="Download on the App Store"
            component="img"
            height={45}
            loading="lazy"
            src={AppStore}
            width={130}
          >
          </Box>
        </Button>
        <Button
          aria-label="Get it on Google Play"
          href="https://play.google.com/store/apps/details?id=com.personalarch.designer.twa"
        >
          <Box
            alt="Get it on Google Play"
            component="img"
            height={45}
            loading="lazy"
            src={GooglePlay}
            width={130}
          >
          </Box>
        </Button>
      </Box>
    </Box>
  )
}

export default Accessibility